import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { CountUp } from 'countup.js';
import { Modal } from 'bootstrap';

// Mobile Height Hack
const mobileHeight = () => {
   let vh = window.innerHeight * 0.01;
   document.documentElement.style.setProperty('--vh', `${vh}px`);
}

mobileHeight();

// Masonry Download Grid

const gridDownload = document.querySelector('.grid-download');

if (gridDownload) {
   imagesLoaded(gridDownload, function () {
      // init Isotope after all images have loaded
      new Masonry(gridDownload, {
         itemSelector: '.grid-download-item',
         columnWidth: '.grid-download-sizer',
         transitionDuration: 0,
         percentPosition: true
      })
   })
}


// Swiper Gallery
const swiperGallery = new Swiper(".swiper-gallery", {
   modules: [Autoplay, Pagination, Navigation],
   spaceBetween: 30,
   autoHeight: true,
   loop: true,
   allowTouchMove: true,
   slidesPerView: "auto",
   centeredSlides: true,

   pagination: {
      el: ".swiper-teaser-pagination",
      type: "fraction",
      // clickable: true,
   },
   navigation: {
      nextEl: '.swiper-teaser-next',
      prevEl: '.swiper-teaser-prev',
   },
   keyboard: {
      enabled: true,
      onlyInViewport: true,
   },
   a11y: {
      prevSlideMessage: 'Einen Slide zurück',
      nextSlideMessage: 'Einen Slide vor',
   }
})

// Swiper Teaser Big
const swiperTeaserBig = new Swiper(".swiper-teaser-big", {
   modules: [Autoplay, Pagination, Navigation],
   slidesPerView: 1,
   spaceBetween: 30,
   // autoHeight: true,
   loop: true,
   allowTouchMove: true,

   breakpoints: {
      768: {
         slidesPerView: 2
      }
   },
   pagination: {
      el: ".swiper-teaser-pagination",
      clickable: true,
   },
   navigation: {
      nextEl: '.swiper-teaser-next',
      prevEl: '.swiper-teaser-prev',
   },
})

// Swiper Teaser Highlight
const swiperTeaserHighlight = new Swiper(".swiper-teaser-highlight", {
   modules: [Autoplay, Pagination, Navigation],
   slidesPerView: 1,
   spaceBetween: 30,
   autoHeight: true,
   loop: true,
   allowTouchMove: true,

   pagination: {
      el: ".swiper-teaser-pagination",
      clickable: true,
   },
   navigation: {
      nextEl: '.swiper-teaser-next',
      prevEl: '.swiper-teaser-prev',
   },
})

// Swiper Teaser Header
const swiperTeaserHeader = new Swiper(".swiper-teaser-header", {
   modules: [Autoplay, Pagination, Navigation],
   slidesPerView: 1,
   spaceBetween: 30,
   autoHeight: true,
   loop: true,
   allowTouchMove: true,

   pagination: {
      el: ".swiper-teaser-header-pagination",
      clickable: true,
   },
   navigation: {
      nextEl: '.swiper-teaser-header-next',
      prevEl: '.swiper-teaser-header-prev',
   },
})

// Swiper Teaser Content
const swiperContent = new Swiper(".swiper-content", {
   modules: [Autoplay, Pagination, Navigation],
   slidesPerView: 1,
   spaceBetween: 30,
   autoHeight: true,
   loop: true,
   allowTouchMove: true,

   pagination: {
      el: ".swiper-teaser-pagination",
      clickable: true,
   },
   navigation: {
      nextEl: '.swiper-teaser-next',
      prevEl: '.swiper-teaser-prev',
   },
})


// ScrollToTop
const scrollToTop = document.querySelector('.side-totop');

if (scrollToTop) {
   scrollToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
   })

   window.onscroll = function () { scrollFunction() };

   function scrollFunction() {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
         scrollToTop.classList.add('show');
      } else {
         scrollToTop.classList.remove('show');
      }
   }
}


// Countupjs Teaser Number

const counterTeaserNumbers = document.querySelectorAll(".teaser-number");

if (counterTeaserNumbers) {
   counterTeaserNumbers.forEach(function (counterTeaserNumber) {

      const counterTeaserNumberOption = {
         separator: ".",
         duration: 2.5,
      };

      const counterTeaserNumberOptionDecimal = {
         decimalPlaces: 2,
         decimal: ',',
         separator: ".",
         duration: 2.5,
      };

      let counterTeaserNumberItem = counterTeaserNumber.querySelector(".teaser-number__number");
      let counterTeaserNumberData = counterTeaserNumberItem.dataset.number;
      let counterTeaserNumberDataDecimal = counterTeaserNumberItem.dataset.mode;
      let countUp = new CountUp(counterTeaserNumberItem, counterTeaserNumberData, counterTeaserNumberOption);

      const observeOptions = {
         root: null,
         threshold: 0.75,
      };

      if (counterTeaserNumberDataDecimal == "decimal") {
         let countUpDezimal = new CountUp(counterTeaserNumberItem, counterTeaserNumberData, counterTeaserNumberOptionDecimal);

         const observerTeaserNumberDecimal = new IntersectionObserver(function (entries, observer) {
            entries.forEach((entry) => {
               if (!entry.isIntersecting) {
                  return;
               } else {
                  countUpDezimal.start();
                  observerTeaserNumberDecimal.unobserve(entry.target);
               }
            });
         }, observeOptions);

         observerTeaserNumberDecimal.observe(counterTeaserNumber);
      } else {
         const observerTeaserNumber = new IntersectionObserver(function (entries, observer) {
            entries.forEach((entry) => {
               if (!entry.isIntersecting) {
                  return;
               } else {
                  countUp.start();
                  observerTeaserNumber.unobserve(entry.target);
               }
            });
         }, observeOptions);

         observerTeaserNumber.observe(counterTeaserNumber);
      }
   });
}


// Search Toggle
const searchToggle = document.getElementById("searchToggle");
const searchBar = document.getElementById("searchBar");
const searchInput = document.getElementById("queryinput");

function openSearch() {
   searchToggle.setAttribute('aria-expanded', 'true');
   searchBar.classList.add('show');
   searchInput.focus();
}

function closeSearch() {
   searchToggle.setAttribute('aria-expanded', 'false');
   searchBar.classList.remove('show');
}

searchToggle.addEventListener('click', () => {
   if (searchBar.classList.contains('show')) {
      closeSearch();
   } else {
      closeNavigation();
      openSearch();
   }
});


// Filter Toggle
const filterToggle = document.getElementById("filterToggle");
const filterBar = document.getElementById("filterBar");

if (filterToggle) {
   function openFilter() {
      filterToggle.setAttribute('aria-expanded', 'true');
      filterBar.classList.add('show');
   }

   function closeFilter() {
      filterToggle.setAttribute('aria-expanded', 'false');
      filterBar.classList.remove('show');
   }

   filterToggle.addEventListener('click', () => {
      if (filterBar.classList.contains('show')) {
         closeFilter();
      } else {
         openFilter();
      }
   });
}


// Navigation Mobile
const navToggle = document.getElementById("navToggle");
const navigation = document.getElementById("navigation");
const navOverlay = document.getElementById("navOverlay");
const body = document.body;

function openNavigation() {
   body.classList.add('overflow');
   navToggle.classList.add('navheader__toggle--active');
   navToggle.setAttribute('aria-expanded', 'true');
   navigation.classList.add('navigation--active');
   navOverlay.classList.add('navigation-overlay--active');
}

function closeNavigation() {
   body.classList.remove('overflow');
   navToggle.classList.remove('navheader__toggle--active');
   navToggle.setAttribute('aria-expanded', 'false');
   navigation.classList.remove('navigation--active');
   navOverlay.classList.remove('navigation-overlay--active');
}

navToggle.addEventListener('click', () => {
   if (navigation.classList.contains('navigation--active')) {
      closeNavigation();
   } else {
      closeSearch();
      openNavigation();
   }
});

navOverlay.addEventListener('click', () => {
   closeNavigation();
});

window.addEventListener("resize", () => {
   closeNavigation();
});

const navSublists = document.querySelectorAll('.navigation__sublist');

navSublists.forEach(function (navSublist) {
   const navMore = navSublist.parentNode.children[1];
   const navSublistParent = navSublist.parentNode;

   navMore.addEventListener('click', () => {
      if (navSublistParent.classList.contains('navigation__item--active')) {
         navSublistParent.classList.toggle('navigation__item--toggle-active');
      } else {
         navSublistParent.classList.toggle('navigation__item--toggle');
      };
   });
});

const navHeader = document.querySelector(".navheader");

if (navHeader) {
   //Responsive Functions Navigation
   var alterClass = function () {
      var ww = window.innerWidth;
      if (ww < 992) {
         navHeader.classList.remove('desktop');
         navHeader.classList.remove('navheader--scrollup');
         navHeader.classList.add('mobile');

         if (navHeader.classList.contains("mobile")) {
            window.onscroll = () => scrollNavigationUp();
         }

      } else if (ww >= 992) {
         navHeader.classList.remove('mobile');
         navHeader.classList.remove('navheader--scroll');
         navHeader.classList.remove('navheader--scrollup');
         navHeader.classList.add('desktop');

         if (navHeader.classList.contains("desktop")) {
            window.onscroll = () => scrollNavigation();
         }

      };
   };

   window.addEventListener("resize", () => {
      alterClass();
   });

   // window.onresize = function () {
   //    alterClass();
   // }

   alterClass();

   //Functions Navigation Dektop
   function scrollNavigation() {
      if (document.body.scrollTop > 140 || document.documentElement.scrollTop > 140) {
         navHeader.classList.add('navheader--scroll');
      } else {
         navHeader.classList.remove('navheader--scroll');
      }
   }

   //Functions Navigation Mobile
   let prevScrollPos = window.pageYOffset;

   function scrollNavigationUp() {
      let currentScrollPos = window.pageYOffset;

      if (prevScrollPos > currentScrollPos) {
         navHeader.classList.remove('navheader--scrollup');
      } else {
         navHeader.classList.add('navheader--scrollup');
      }
      prevScrollPos = currentScrollPos;
   }
}

function initLoadMoreBtn(button, url = '?', success = () => { }, fail = () => { }) {
   button.addEventListener('click', () => {
      if (!button.classList.contains('btn-loader--spinning')) {
         button.classList.add('btn-loader--spinning')
         const page = parseInt(button.dataset.page)

         fetch(url + 'page=' + page, {
            headers: {
               'X-Requested-With': 'XMLHttpRequest'
            }
         })
            .then(response => {
               if (response.status >= 200 && response.status < 400) {
                  return response.json()
               }

               return response.json()
                  .then(json => Promise.reject(json))
            })
            .then(response => {
               button.dataset.page = page + 1

               success(response)
            })
            .catch(error => {
               fail(error)
            })
            .finally(() => {
               button.classList.remove('btn-loader--spinning')
            })
      }
   })
}

// More Article Button

const btnMoreArticles = document.querySelectorAll('.btn-more-articles')

if (btnMoreArticles) {
   const url = location.search.length ? location.search + '&' : '?'

   btnMoreArticles.forEach(button => {
      initLoadMoreBtn(button, url,
         response => {
            const articleTeasers = document.querySelector('#article-teasers .teaser-container')
            articleTeasers.innerHTML += response.teasers

            if (response.hasMoreArticles === false) {
               button.style.display = 'none'
            }
         },
         error => {
            console.log(error)
         }
      )
   })
}

// More Search Results Button

const btnMoreResults = document.getElementById('btn-more-results')

if (btnMoreResults) {
   const url = location.search.length ? location.search + '&' : '?'

   initLoadMoreBtn(btnMoreResults, url,
      response => {
         const existingDownloadBts = Array.from(document.querySelectorAll('.download-file-btn'))

         const resultList = document.getElementById('search-result-list')
         resultList.innerHTML += response.results

         const newDownloadBtns = document.querySelectorAll('.download-file-btn')

         newDownloadBtns.forEach(newDownloadBtn => {
            if (!existingDownloadBts.includes(newDownloadBtn)) {
               newDownloadBtn.addEventListener('click', downloadAction)
            }
         })

         if (response.hasMoreResults === false) {
            btnMoreResults.style.display = 'none'
         }
      },
      error => {
         console.log(error)
      }
   )
}

// Zip download

const downloadBtn = document.getElementById('article-zip-btn')

if (downloadBtn) {
   downloadBtn.addEventListener('click', function () {
      let blob
      let filename
      const progressBar = document.getElementById('zip-progress')
      const xmlHTTP = new XMLHttpRequest()
      const url = downloadBtn.href

      downloadBtn.disabled = true
      downloadBtn.querySelector('.spinner-border').classList.remove('d-none')

      progressBar.parentElement.classList.remove('d-none')

      xmlHTTP.open('GET', '', true)
      xmlHTTP.responseType = 'arraybuffer'
      xmlHTTP.setRequestHeader('X-Requested-With', 'XMLHttpRequest')

      xmlHTTP.onload = function (event) {
         blob = new Blob([this.response]);
         const contentDispo = event.currentTarget.getResponseHeader('Content-Disposition');
         filename = contentDispo.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/)[1];
      }

      xmlHTTP.onprogress = function (event) {
         let progress = (event.loaded / event.total) * 100
         if (progress === Infinity) {
            progress = 100
         }
         const progrssFixed = progress.toFixed(0)

         progressBar.setAttribute('aria-valuenow', progrssFixed)
         progressBar.style.width = progrssFixed + '%'
         progressBar.innerText = progrssFixed + '%'
      }

      xmlHTTP.onloadend = function () {
         const url = window.URL.createObjectURL(blob)
         const tempEl = document.createElement("a")

         tempEl.style = "display: none"
         tempEl.href = url
         tempEl.download = filename

         document.body.appendChild(tempEl)

         tempEl.click()
         tempEl.remove()

         window.URL.revokeObjectURL(url)

         progressBar.setAttribute('aria-valuenow', 0)
         progressBar.style.width = 0 + '%'
         progressBar.innerText = 0 + '%'

         downloadBtn.disabled = false
         downloadBtn.querySelector('.spinner-border').classList.add('d-none')
         const modal = Modal.getInstance(document.getElementById('zipModal'))
         modal.hide()
      }

      xmlHTTP.send();
   })
}

const downloadBtns = document.querySelectorAll('.download-file-btn')

downloadBtns.forEach(downloadBtn => {
   downloadBtn.addEventListener('click', downloadAction)
})

function downloadAction(event) {
   event.preventDefault()
   const downloadBtn = this

   let blob
   let filename
   const fileid = downloadBtn.dataset.file
   const width = downloadBtn.dataset.width
   let url = downloadBtn.href + '?file=' + fileid

   if (width) {
      url += '&width=' + width
   }

   const xmlHTTP = new XMLHttpRequest()

   downloadBtn.disabled = true

   xmlHTTP.open('POST', url, true)
   xmlHTTP.responseType = 'arraybuffer'
   xmlHTTP.setRequestHeader('X-Requested-With', 'XMLHttpRequest')

   xmlHTTP.onload = function (event) {
      blob = new Blob([this.response]);
      const contentDispo = event.currentTarget.getResponseHeader('Content-Disposition');
      filename = contentDispo.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/)[1];
   }

   xmlHTTP.onloadend = function () {
      const url = window.URL.createObjectURL(blob)
      const tempEl = document.createElement("a")

      tempEl.style = "display: none"
      tempEl.href = url
      tempEl.download = filename

      document.body.appendChild(tempEl)

      tempEl.click()
      tempEl.remove()

      window.URL.revokeObjectURL(url)

      progressBar.setAttribute('aria-valuenow', 0)
      progressBar.style.width = 0 + '%'
      progressBar.innerText = 0 + '%'

      downloadBtn.disabled = false
   }

   xmlHTTP.send();
}

const youtubeVideos = document.querySelectorAll('.youtube-video')

youtubeVideos.forEach(video => {
   const iframe = video.querySelector('.youtube-video__embeded')
   const poster = video.querySelector('.youtube-video__poster')

   poster.addEventListener('click', () => {
      iframe.setAttribute('src', iframe.dataset.src)
      poster.classList.add('youtube-video__poster--hidden')
   })
})


// Hide WhatsApp share button if not mobile/tablet
// const mobileAndTabletCheck = () => {
//    let check = false;
//    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
//    return check;
// }
// if(!mobileAndTabletCheck()) {
//    const whatsappShareButton = document.querySelector('.shariff-button.whatsapp');
//    if(whatsappShareButton) {
//       whatsappShareButton.style.display = 'none';
//    }
// }